import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const closeAccoutSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    closeAccount: build.mutation<any, { email: string }>({
      query: (body: any) => ({
        url: `${urlConfig.authBaseUrl}/auth/users/close-otp`,
        method: 'DELETE',
        body,
      }),
    }),

    validateCloseAccount: build.mutation<any, { email: string; otp: number }>({
      query: (body: any) => ({
        url: `${urlConfig.authBaseUrl}/auth/users/close-otp/confirm`,
        method: 'DELETE',
        body,
      }),
    }),
  }),
})

export const { useCloseAccountMutation, useValidateCloseAccountMutation } =
  closeAccoutSlice
